document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.unfold-inner').forEach((unfoldContainer) => {
    const contentShowEvent = unfoldContainer.getAttribute('data-content-show-event');
    const hideUnfoldButton = unfoldContainer.getAttribute('data-hide-unfold-button') === '1';
    const unfoldContent = unfoldContainer.querySelector('.unfold-content');
    const unfoldContentup = unfoldContainer.querySelector('.vb-bg-unfold-full-button');
    const unfoldButton = unfoldContainer.querySelector('.unfold-button');

    if (!unfoldContent) return;

    // Function to toggle unfold content visibility
    function toggleUnfold() {
      const isUnfolded = unfoldContent.classList.contains('unfolded');
      unfoldContent.classList.toggle('unfolded', !isUnfolded);

      const isUnfoldedup = unfoldContentup.classList.contains('unfolded');
      unfoldContentup.classList.toggle('unfolded', !isUnfoldedup);

      if (unfoldButton) {
        const foldText = unfoldButton.getAttribute('data-fold-text');
        const unfoldText = unfoldButton.getAttribute('data-unfold-text');

        const buttonText = unfoldButton.querySelector('.btn-text');
        if (buttonText) {
          buttonText.innerText = isUnfolded ? unfoldText : foldText;
        }

        const btnFoldIcon = unfoldButton.querySelector('.btn-fold-icon');
        const btnUnfoldIcon = unfoldButton.querySelector('.btn-unfold-icon');

        if (btnFoldIcon && btnUnfoldIcon) {
          btnFoldIcon.style.display = isUnfolded ? 'none' : 'inline-flex';
          btnUnfoldIcon.style.display = isUnfolded ? 'inline-flex' : 'none';
        }

        unfoldButton.setAttribute('aria-expanded', !isUnfolded);
      }
    }

    // Content click event
    if (contentShowEvent === 'contentclick') {
      unfoldContainer.addEventListener('click', toggleUnfold);
    }

    // Content hover events
    if (contentShowEvent === 'contenthover') {
      unfoldContainer.addEventListener('mouseenter', () => {
        unfoldContent.classList.add('unfolded');
        unfoldContentup.classList.add('unfolded');
      });
      unfoldContainer.addEventListener('mouseleave', () => {
        unfoldContent.classList.remove('unfolded');
        unfoldContentup.classList.remove('unfolded');
      });
    }

    // Button click event
    if (contentShowEvent === 'buttonclick' || !hideUnfoldButton) {
      if (unfoldButton) {
        unfoldButton.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleUnfold();
        });
      }
    }
  });
});
